import IDSecureService from '../../../services/idsecure/idsecureService';
const api = new IDSecureService()
const state = {
  devices:[],
  devices_loading:false,
  visitantes:[],
  visitantes_grupos:[],
  visitantes_grupos_loading:false,
  visitantes_loading:false,
  pessoas_loading:false,
};
const getters = {
  StateDevices: state => state.devices,
  StateDevicesLoading: state => state.devices_loading,
  StateVisitantesGrupos: state => state.visitantes_grupos,
  StateVisitantesGruposLoading: state => state.visitantes_grupos_loading,
  StateIDSecureVisitantes: state => state.visitantes,
  StateIDSecureVisitantesLoading: state => state.visitantes_loading,
  StateIDSecurePessoasLoading: state => state.pessoas_loading,
};
const mutations = {
  SetDevices(state, value){state.devices = value},
  SetDevicesLoading(state, value){state.devices_loading = value},
  SetVisitantesGrupos(state, value){state.visitantes_grupos = value},
  SetVisitantesGruposLoading(state, value){state.visitantes_grupos_loading = value},
  SetIDSecureVisitantes(state, value){state.visitantes = value},
  SetIDSecureVisitantesLoading(state, value){state.visitantes_loading = value},
  SetIDSecurePessoasLoading(state, value){state.pessoas_loading = value},
};
const actions = {
    async GetDevices({commit}, params) {
      commit('SetDevicesLoading', true)
      try{
          let response = await api.get_devices(params)
          let devices = response.data
          commit('SetDevices', devices)
        }catch(error){
          commit('SetDevices', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum dispositivo encontrado!',
              tag: 'warn',
              timeout: '4000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetDevicesLoading', false)
    },
    async TestImage({commit}, params) {
      try{
        let response =  await api.test_photo(params)
        return response
      }catch(error){
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao realizar teste na imagem!`,
            tag: 'error',
            timeout: '5000',
            title: error.response.statusText
          } ])
        }
        return error.response
        // return []
      }
    },
    async SaveToRM({commit}, data) {
      try{
        let response =  await api.save_to_rm(data)
        return response
      }catch(error){
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao enviar cadastro para RM!`,
            tag: 'error',
            timeout: '5000',
            title: error.response.statusText
          } ])
        }
        return error.response
      }
    },
    async GetIDSecureVisitantesGrupos({commit}, params) {
      params
      commit('SetVisitantesGruposLoading', true)
      try{
        let response =  await api.list_visitantes_grupos()
        commit('SetVisitantesGruposLoading', false)
        commit('SetVisitantesGrupos', response.data)
        return response
      }catch(error){
        commit('SetVisitantesGruposLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao carregar Grupos de Visitantes!`,
            tag: 'error',
            timeout: '5000',
            title: error.response.statusText
          }])
          console.error('Error in GetIDSecureVisitantesGrupos',error.response)
        }
        return error.response
      }
    },
    async GetIDSecureVisitantes({commit}, params) {
      commit('SetIDSecureVisitantesLoading', true)
      try{
        let response =  await api.list_visitantes(params)
        commit('SetIDSecureVisitantesLoading', false)
        commit('SetIDSecureVisitantes', response.data)
        return response
      }catch(error){
        commit('SetIDSecureVisitantesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao carregar Visitantes!`,
            tag: 'error',
            timeout: '7000',
            title: error.response.statusText
          }])
          console.error('Error in GetIDSecureVisitantes',error.response)
        }
        return error.response
      }
    },
    async GetIDSecurePessoa({commit}, registration) {
      commit('SetIDSecurePessoasLoading', true)
      try{
        let response =  await api.get_pessoa(registration)
        commit('SetIDSecurePessoasLoading', false)
        return response
      }catch(error){
        commit('SetIDSecurePessoasLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `Pessoa não encontrada no sistema de catracas com a matrícula informada!`,
            tag: 'error',
            timeout: '7000',
            title: error.response.data
          }])
          console.error('Error in GetIDSecurePessoa',error.response)
        }
        return error.response
      }
    },
    async GetIDSecureVisitante({commit}, id) {
      commit('SetIDSecureVisitantesLoading', true)
      try{
        let response =  await api.get_visitante(id)
        commit('SetIDSecureVisitantesLoading', false)
        return response
      }catch(error){
        commit('SetIDSecureVisitantesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao carregar Visitante!`,
            tag: 'error',
            timeout: '7000',
            title: error.response.data
          }])
          console.error('Error in GetIDSecureVisitante',error.response)
        }
        return error.response
      }
    },
    async UpdateIDSecureVisitante({commit}, data) {
      commit('SetIDSecureVisitantesLoading', true)
      try{
        let response =  await api.put_visitante(data.id, data)
        commit("setAlerts", [ {
          message: `Visitante atualizado com sucesso!`,
          tag: 'success',
          timeout: '7000',
          title: 'Alteração de Visitante'
        } ])
        commit('SetIDSecureVisitantesLoading', false)
        return response
      }catch(error){
        commit('SetIDSecureVisitantesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao atualizar o Visitante!`,
            tag: 'error',
            timeout: '5000',
            title: error.response.data
          } ])
          console.error('Error in UpdateVisitante',error.response)
        }
        return error.response
      }
    },
    async CreateIDSecureVisitante({commit}, data) {
      commit('SetIDSecureVisitantesLoading', true)
      try{
        let response =  await api.post_visitante(data)
        commit("setAlerts", [ {
          message: `Visitante cadastrado com sucesso!`,
          tag: 'success',
          timeout: '5000',
          title: 'Cadastro de Visitante'
        } ])
        commit('SetIDSecureVisitantesLoading', false)
        return response
      }catch(error){
        commit('SetIDSecureVisitantesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao cadastrar Visitante!`,
            tag: 'error',
            timeout: '5000',
            title: error.response.data
          } ])
          console.error('Error in SaveVisitante',error.response)
        }
        return error.response
      }
    },
    async CreateIDSecureVisitanteBySolicitacao({commit}, data) {
      commit('SetIDSecureVisitantesLoading', true)
      try{
        let response =  await api.post_visitante_solicitacao(data)
        commit("setAlerts", [ {
          message: `Visitante cadastrado com sucesso!`,
          tag: 'success',
          timeout: '5000',
          title: 'Cadastro de Visitante'
        } ])
        commit('SetIDSecureVisitantesLoading', false)
        return response
      }catch(error){
        commit('SetIDSecureVisitantesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao cadastrar Visitante!`,
            tag: 'error',
            timeout: '5000',
            title: error.response.data
          } ])
          console.error('Error in SaveVisitante',error.response)
        }
        return error.response
      }
    },
    async GetDeviceChild({commit, getters}, params) {
      commit('SetDevicesLoading', true)
      try{
        let response = await api.get_device_child(params)
        let equips = getters.StateDevices
        equips.data = equips.data.map(obj => {
          if (obj.id === params.id){
            return {...obj, child: response.data}
          }else{
            return {...obj}
          }
        })
        commit('SetDevices', equips)
        commit('SetDevicesLoading', false)
        // return response.data
      }catch(error){
        if (error.response && error.response.status === 404){
          commit("setAlerts", [ {
            message: 'Dispositivo não encontrado!',
            tag: 'warn',
            timeout: '5000',
            title: 'Nada encontrado'
          } ])
        }
        commit('SetDevicesLoading', false)
        // return []
      }
    },
    async TestConnect({commit}, data) {
      commit('SetDevicesLoading', true)
      try{
        let response = await api.test_connect(data)
        if(response.data){
          if (response.data.success){
            commit("setAlerts", [ {
              message: 'Dispositivo OK!',
              tag: 'success',
              timeout: '5000',
              title: 'Teste de Conexão'
            } ])
          } else {
            commit("setAlerts", [ {
              message: 'Dispositivo Fora do ar!',
              tag: 'error',
              timeout: '10000',
              title: 'Teste de Conexão'
            } ])
          }
        }
        commit('SetDevicesLoading', false)
        // return response.data
      }catch(error){
        if (error.response && error.response.status === 404){
          commit("setAlerts", [ {
            message: 'Dispositivo não encontrado!',
            tag: 'warn',
            timeout: '5000',
            title: 'Nada encontrado'
          } ])
        }
        commit('SetDevicesLoading', false)
      }
    },
    async GetLogVisitante({commit}, id) {
      commit('SetIDSecureVisitantesLoading', true)
      try{
        let response =  await api.get_log_visitante(id)
        commit('SetIDSecureVisitantesLoading', false)
        return response
      }catch(error){
        commit('SetIDSecureVisitantesLoading', false)
        if (error.response){
          commit("setAlerts", [ {
            message: `${error.response.status} - Falha ao carregar Logs do Visitante!`,
            tag: 'error',
            timeout: '7000',
            title: error.response.data
          }])
          console.error('Error in GetLogVisitante',error.response)
        }
        return error.response
      }
    },
  };
export default {
  state,
  getters,
  actions,
  mutations
};